<template>
  <div class="invoice-view">
    <v-card flat v-if="isLoading">
      <v-card-text>
        <v-progress-linear :indeterminate="true"></v-progress-linear>
      </v-card-text>
    </v-card>
    <div v-else>
      <v-card flat>
        <ReportViewBar v-if="Product" :title="`Invoices By Product`" />

        <v-container fluid>
          <table class="center">
            <tbody class="report-container">
              <v-card-text class="pt-0">
                <v-data-table
                  dense
                  :headers="headers"
                  :expanded.sync="expanded"
                  show-expand
                  :itemsPerPage="Product.length"
                  hide-default-footer
                  :items="Product"
                >
                  <template v-slot:item="{ item, isExpanded, expand }">
                    <tr>
                      <td class="text-left ">
                        <v-btn
                          class="no-print"
                          @click="expand(true)"
                          icon
                          v-if="!isExpanded"
                          ><v-icon>mdi-chevron-down</v-icon></v-btn
                        >
                        <v-btn
                          class="no-print"
                          @click="expand(false)"
                          icon
                          v-if="isExpanded"
                          ><v-icon>mdi-chevron-up</v-icon></v-btn
                        >
                      </td>
                      <td class="text-left">{{ item.name }}</td>
                      <td class="text-right">{{ item.price | currency }}</td>
                    </tr>
                  </template>
                  <template v-slot:expanded-item="{ headers, item }">
                    <td :colspan="headers.length" class="pa-0">
                      <v-card color="#F3F8FC" flat>
                        <v-card-text class="title">
                          <Invoice :ProductId="item.id" :start="start" :end="end" :includeDetails="true" ></Invoice>
                        </v-card-text>
                      </v-card>
                    </td>
                  </template>
                  <template
                    v-slot:body.append="{ headers }"
                    v-if="Product.length > 0"
                  >
                    <tr>
                      <td></td>
                      <td
                        :colspan="headers.length - 3"
                        class="text-right font-weight-bold"
                      >
                        Total
                      </td>
                      <td class="text-right font-weight-bold">
                        {{ total | currency }}
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card-text>
            </tbody>
          </table>
        </v-container>
      </v-card>
    </div>
  </div>
</template>

<script>
import ReportViewBar from "@/components/ReportViewBar";
import productService from "@/modules/Product/service";
import Invoice from "@/modules/ReportView/components/invoice/components/Invoice.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      isLoading: true,
      Product: null,
      start: null,
      end: null,
      expanded: [],
      headers: [
        { text: "", value: "data-table-expand" },
        {
          text: "Product Name",
          align: "left",
          value: "name",
          sortable: false,
        },

        {
          text: "Product Amount",
          align: "right",
          value: "price",
          sortable: false,
        },
      ],
    };
  },
  computed: {
    ...mapGetters("global", ["currentBusiness"]),
    total() {
      let total = 0;
      this.Product.map((row) => {
        total += row.price;
      });

      return total;
    },
  },
  created() {
    this.loadData();
    if (!this.currentBusiness) this.initUser();
  },
  components: { ReportViewBar, Invoice },
  methods: {
    ...mapActions("global", ["initUser", "initBusiness"]),
    loadData() {
      this.start = this.$route.query.start;
      this.end = this.$route.query.end;
      return productService
        .getAll()
        .then((response) => {
          this.$Progress.finish();
          this.Product = response.data;
          document.title = `Report - Product Invoice`;

          this.isLoading = false;
        });
    },
  },
};
</script>

<style scoped>
@media print {
  container {
    height: 100%;
    margin: 0 !important;
    padding: 0 !important;
    overflow: hidden;
  }
  .no-print {
    display: none;
  }
  .detailBox {
    overflow: visible;
    height: 100%;
  }
  * {
    background: 0 0 !important;
    color: #000 !important;
    box-shadow: none !important;
    text-shadow: none !important;
  }
}
.paidImg {
  position: absolute;
  left: 40%;
  top: 10%;
}

.signature {
  margin-top: 100px;
}
.center {
  background-color: white;
  margin: auto;
  width: 100%;
}
</style>
